import { render } from "./RelatedProducts.vue?vue&type=template&id=8b930c64&scoped=true"
import script from "./RelatedProducts.vue?vue&type=script&lang=js"
export * from "./RelatedProducts.vue?vue&type=script&lang=js"

import "./RelatedProducts.vue?vue&type=style&index=0&id=8b930c64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b930c64"]])

export default __exports__